export const HEADLINE_CONFIG = {
    healthy: {
        headline: 'Scale your prospecting',
        subtext: 'Move to a higher plan to unlock more credits and advanced capabilities.',
    },
    almostOut: {
        headline: 'Ready for more?',
        subtext: `You’re almost at your limit. Keep your momentum going.`,
    },
    outOfCredits: {
        headline: "Don't lose momentum",
        subtext: `You’ve hit your limit. Upgrade to keep building your pipeline today.`,
    },
};
export const BILLING_CYCLES = {
    MONTHLY: 'monthly',
    ANNUAL: 'annual',
};
export const DEFAULT_BILLING_CYCLE = BILLING_CYCLES.ANNUAL;
export const PLAN_CODES = {
    PRO: 'professional',
    STARTER: 'starter',
    PREMIUM: 'premium',
};
export const DEFAULT_SEAT_AMOUNT = 2;
export const STARTER_SEAT_AMOUNT = 1;
export const PREMIUM_SEAT_AMOUNT = 5;
export const SEATS_ONLY_PRODUCT_CODE = 'SEATS_ONLY';
export const DYNAMIC_PLAN_CODES = [PLAN_CODES.PRO, PLAN_CODES.PREMIUM];
export const DYNAMIC_PLANS = {
    [PLAN_CODES.PRO]: {
        name: 'Pro',
        baseSeatAmount: DEFAULT_SEAT_AMOUNT,
        featuresTitle: 'Everything in Starter, plus:',
    },
    [PLAN_CODES.PREMIUM]: {
        name: 'Premium',
        baseSeatAmount: PREMIUM_SEAT_AMOUNT,
        featuresTitle: 'Everything in Pro, plus:',
    },
};
export const DEFAULT_EXPANDED_PLAN = PLAN_CODES.PREMIUM;
